module.exports = __webpack_public_path__ + "static/media/trieste-19.b3f63344.jpg";